module.exports = __webpack_public_path__ + "img/hopital-montfort.309ec4af.png";